export default __webpack_public_path__ + "static/security-mobile-83e93b7b5ca25000c70e4775f9fe62a0.svg";